import { createFileRoute } from '@tanstack/react-router'
import { Button, Paper } from '@mantine/core'
import { authClient } from '../lib/auth-client'

export const Route = createFileRoute('/login')({
  component: LoginPage,
})

function LoginPage() {
  const handleLogin = () => {
    authClient.signIn.oauth2({
      providerId: 'zitadel',
      callbackURL: '/admin',
    })
  }

  return (
    <main className="flex min-h-[70vh] items-center justify-center px-4">
      <Paper withBorder radius={16} className="w-full max-w-sm p-8 text-center">
        <svg
          viewBox="0 0 16 16"
          width="32"
          height="32"
          aria-hidden="true"
          className="mx-auto mb-5 text-slate-900 dark:text-white"
        >
          <rect x="0" y="0" width="7" height="7" rx="1.5" fill="currentColor" />
          <rect x="9" y="0" width="7" height="7" rx="1.5" fill="currentColor" />
          <rect x="0" y="9" width="7" height="7" rx="1.5" fill="currentColor" />
          <rect
            x="9"
            y="9"
            width="7"
            height="7"
            rx="1.5"
            className="fill-blue-700 dark:fill-blue-400"
          />
        </svg>
        <p className="mb-2 font-mono text-[0.62rem] font-semibold uppercase tracking-[0.16em] text-slate-400 dark:text-slate-500">
          Operator console
        </p>
        <h1 className="mb-2 text-2xl font-bold tracking-tight text-slate-900 font-stretch-[112%] dark:text-white">
          Sign in to Lugstash
        </h1>
        <p className="mb-8 text-sm leading-6 text-slate-600 dark:text-slate-400">
          Manage your walls, cells, and deliveries from one screen.
        </p>
        <Button fullWidth size="md" onClick={handleLogin}>
          Sign in with Zitadel
        </Button>
      </Paper>
    </main>
  )
}
